import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { ContactMembersMenu } from "./contact-member-menu";
import { columns } from "./table-config";

/** Props Interface */
interface ContactMembersProps {
	contactId: string;
}

export function ContactMembers({ contactId }: ContactMembersProps) {
	/** Hooks */

	/** Query */
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["contact", "members", contactId],
		queryFn: async () => {
			const response = await client.contacts[":contactId"].members.$get({
				param: {
					contactId,
				},
			});
			const data = await responseHandler(response);
			if (!data.members) throw new Error("Failed to fetch contact members");
			return data.members;
		},
	});

	/** Render */
	return (
		<DataTable
			data={data}
			columns={columns}
			persistenceKey="contact-members-table"
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={
				<ContactMembersMenu
					refetch={refetch}
					contactId={contactId}
				/>
			}
		/>
	);
}
